<template>
  <modal v-bind="[$props, $attrs]"
         class="reservation-modal"
         @modal-close="emitCloseEvent">
    <template #body>
      <base-inline-loader v-if="$props.loading" height="360"/>
      <order-confirmation v-else-if="$props.reservationStatus"
                          :showButtons="false"
                          :order-data="reservationOrderData"
                          :order-config="$props.reservationStatus === 'success' ? success : fail"/>
      <template v-else>
        <div class="reservation">
          <span class="reservation-title">{{ $t('modalReservation.title') }}</span>
          <span class="reservation-description">{{ $t('modalReservation.description') }}</span>
        </div>
        <validation-observer ref="reservation"
                             tag="form"
                             class="reservation-form"
                             @submit.prevent="submitForm">
          <base-v-input v-model="$props.value.name"
                        :label="$t('form.firstAndLastName')"
                        :submitted="reservationSubmitted"
                        rules="required"/>
          <base-v-input v-model="$props.value.email"
                        :label="$t('form.email')"
                        :submitted="reservationSubmitted"
                        rules="required|email"/>
          <base-v-input v-model="$props.value.phone"
                        :label="$t('form.contactNumber')"
                        :submitted="reservationSubmitted"
                        rules="required"
                        :maxlength="15"/>
          <base-button type="submit">
            {{ $t('modalReservation.sendInquiry') }}
          </base-button>
        </validation-observer>
      </template>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/common/modal/modal'
import BaseVInput from '@/components/base/base-v-input'
import BaseButton from '@/components/base/base-button'
import OrderConfirmation from '@/components/checkout/order-confirmation/order-confirmation'
import BaseInlineLoader from '@/components/base/base-inline-loader'
import { ValidationObserver } from 'vee-validate'
import { reservationSuccess, reservationFail } from '@/components/checkout/config/orderConfirmationProps'
import '@/config/validation/vee-validate-config'

export default {
  name: 'modal-reservation',
  components: { Modal, BaseVInput, BaseButton, OrderConfirmation, BaseInlineLoader, ValidationObserver },
  inheritAttrs: false,
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    reservationOrderData: {
      type: Object,
      default: () => ({})
    },
    reservationStatus: null,
    loading: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      reservationSubmitted: false
    }
  },

  computed: {
    success () {
      return { ...reservationSuccess(this) }
    },
    fail () {
      return { ...reservationFail(this) }
    },
    countSpecialChars () {
      if (this.$props.value.phone.startsWith('00')) {
        return Math.min(this.value.phone.replace(/[0-9a-zA-Z]/g, '').length + 2, 5)
      }
      return Math.min(this.value.phone.replace(/[0-9a-zA-Z]/g, '').length, 5)
    }
  },
  methods: {
    async submitForm () {
      const valid = await this.$refs.reservation.validate()
      this.reservationSubmitted = true
      if (valid) {
        this.$emit('reservation-valid')
        this.reservationSubmitted = false
      }
    },
    emitCloseEvent () {
      this.$emit('close')
      this.reservationSubmitted = false
    }
  }
}
</script>

<style lang="scss" scoped>
.reservation-modal {
  /deep/ .custom-modal__container {
    padding: 1.4rem 2.4rem 2.4rem;
  }

  /deep/ .custom-modal__body {
    @media (map_get($breakpoints, sm)) {
      padding: 0 1.6rem;
    }

    @media (map_get($breakpoints, md)) {
      padding: 0 5.6rem;
    }

    .confirmation-order-container {
      padding: 0;
    }
  }

  .base-button {
    width: 100%;
  }
}

.reservation {
  margin: 2.4rem 0;
  text-align: center;

  @media (map_get($breakpoints, sm)) {
    margin: 0 0 4rem;
  }
}

.reservation-title {
  display: block;
  margin-bottom: 1.6rem;
  color: $text;
  font-size: 2rem;

  @media (map_get($breakpoints, sm)) {
    margin-bottom: 2.4rem;
    font-size: 2.8rem;
  }
}

.reservation-description {
  color: $text;
  font-size: 1.4rem;

  @media (map_get($breakpoints, sm)) {
    font-size: 1.6rem;
  }
}

.reservation-form {
  @media (map_get($breakpoints, sm)) {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    margin: 0 -2rem;
  }

  .validated-input, .base-button {
    @media (map_get($breakpoints, sm)) {
      flex: 0 0 calc(50% - 4rem);
      margin: 0 2rem;
    }
  }

  .base-button {
    @media (map_get($breakpoints, sm)) {
      margin-bottom: 3rem;
    }
  }
}
</style>
